import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { LangProvider } from "@/lib/lang";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";

import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import Gallery from "@/pages/Gallery";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PreWedding from "@/pages/PreWedding";
import Reels from "@/pages/Reels";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Review from "@/pages/Review";
import AllReviews from "@/pages/AllReviews";
import LocationLanding from "@/pages/LocationLanding";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminBookings from "@/pages/AdminBookings";
import AdminCalendar from "@/pages/AdminCalendar";
import AdminEvents from "@/pages/AdminEvents";
import ClientPortal from "@/pages/ClientPortal";
import AdminTeam from "@/pages/AdminTeam";
import AdminPackages from "@/pages/AdminPackages";
import AdminGallery from "@/pages/AdminGallery";
import AdminMasterData from "@/pages/AdminMasterData";
import AdminReviews from "@/pages/AdminReviews";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LangProvider>
          <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            {/* Public */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/pre-wedding" element={<PreWedding />} />
              <Route path="/reels" element={<Reels />} />
              <Route path="/services" element={<Services />} />
              <Route path="/testimonials" element={<AllReviews />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/review" element={<Review />} />
              <Route path="/reviews" element={<AllReviews />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/wedding-photographer-midnapur" element={<LocationLanding locationKey="midnapur" />} />
              <Route path="/wedding-photographer-contai" element={<LocationLanding locationKey="contai" />} />
              <Route path="/pre-wedding-photographer-digha" element={<LocationLanding locationKey="digha" />} />
              <Route path="/pre-wedding-photographer-tajpur" element={<LocationLanding locationKey="tajpur" />} />
            </Route>

            {/* Admin login */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Client portal (QR auto-login + selfie + album) */}
            <Route path="/client" element={<ClientPortal />} />
            <Route path="/client/scan" element={<ClientPortal />} />

            {/* Admin */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="packages" element={<AdminPackages />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="master-data" element={<AdminMasterData />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </LangProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
